import {
    SET_TIMER_VALUE,
    SET_TIMER_VALUE_SUCCESS,
    SET_EVENT_AUDIO_VALUE,
    SET_EVENT_AUDIO_VALUE_SUCCESS,
    SEND_USER_DETAILS,
    SEND_USER_DETAILS_SUCCESS
} from './constants';

/**
 *
 * @param val
 * @returns {{val: *, type: string}}
 */
const setTimerValue = ( val ) => ( { type: SET_TIMER_VALUE, val } );
/**
 *
 * @param val
 * @returns {{val: *, type: string}}
 */
const setTimerValueSuccess = val => ( {
    type: SET_TIMER_VALUE_SUCCESS,
    val
} );
/**
 *
 * @param quizId
 * @param val
 * @returns {{val: *, quizId: *, type: string}}
 */
const userDetails = ( quizId, val ) => ( {
    type: SEND_USER_DETAILS,
    quizId,
    val
} );
/**
 *
 * @param val
 * @returns {{val: *, type: string}}
 */
const userDetailsSuccess = ( val ) => ( {
    type: SEND_USER_DETAILS_SUCCESS,
    val
} );
/**
 *
 * @param val
 * @returns {{val: *, type: string}}
 */
const setEventSound = ( val ) => ( { type: SET_EVENT_AUDIO_VALUE, val } );
/**
 *
 * @param val
 * @returns {{val: *, type: string}}
 */
const setEventSoundSuccess = ( val ) => ( { type: SET_EVENT_AUDIO_VALUE_SUCCESS, val } );

export { setTimerValue, setTimerValueSuccess, setEventSound, setEventSoundSuccess, userDetails, userDetailsSuccess };